// const AppSideMenu = r => require.ensure([], () => r(require('./AppSideMenu.vue')), 'appsidemenu-chunk')
import AppSideMenu from './AppSideMenu'

export default AppSideMenu
